import client from './client'
import headerAuthorization from './headerAuthorization'

const certificateService = {}

certificateService.certificado = function (token) {
  return client.get(
    `/certificado`,
    headerAuthorization(token)
    )
    .then(res => res.data).catch(function (error) {
      return error
    })
}

certificateService.certificadoCaduca = function () {
  return client.get(`/certificado/caduca`)
    .then(res => res.data).catch(function (error) {
      return error
    })
}

export default certificateService